// @givmo/app-admin — the §317 gift-card disclosure block (EP-WEB4).
//
// Renders the server-driven (or DRAFT-floor) AB 488 §317 pre-purchase disclosure directly above the
// send control in the confirm dialogs, single and batch. The `gift-disclosure` testid stays on the
// block root as the e2e/RTL contract, and the lines render verbatim, one `<li>` per registry line.
//
// THE PRESENTATION IS THE APPROVED TERMS PANEL (CAM-R60): the shared `@givmo/disclosure`
// `DisclosureTerms` in the portal's tokens — the same panel as the Give and approve dialogs (D-CAM-44)
// — under a client-owned "Terms" heading (D-CAM-97: "How about just 'Terms'. definitely not 'before
// you give'"), an h3 under the dialog's title. The FULL text is fine print in a tinted panel bounded
// to five lines, with a drawn scrollbar and a bottom fade, and that fine print is "conspicuous enough"
// for §317 (D-CAM-97). The dialogs place it after their errors, adjacent to the button (D-CAM-41).
//
// WHY THE BOUND. The confirm card is clamped to the viewport and scrolls its own content
// (`Dialog.Content`), but whether its FOOTER is on screen when it OPENS depends on where Base UI's
// initial focus lands — the first tabbable. With the six-item v2 copy an unbounded block alone was
// 684px, so the card outgrew a 720px viewport and Send opened ~1040px down it. The five-line panel
// keeps the card under the clamp, so Send is inside the viewport on open whatever the tab order
// (pinned by e2e `company.gift_cards.react.spec.ts`). Do not cure this by pinning `initialFocus` to
// the footer — that re-creates the accident on purpose.

import { DisclosureTerms } from '@givmo/disclosure';

export interface GiftDisclosureBlockProps {
  /** The disclosure lines (server `content_plaintext` lines, or the compiled-in floor). */
  lines: readonly string[];
}

/** The heading's words — client-owned, NOT part of the counsel-pinned registry copy. */
export const GIFT_TERMS_HEADING = 'Terms';

export function GiftDisclosureBlock({ lines }: GiftDisclosureBlockProps) {
  return (
    <DisclosureTerms
      appearance="saas"
      headingLevel={3}
      heading={GIFT_TERMS_HEADING}
      sections={[{ key: 'gift-card-purchase', label: null, lines }]}
      testId="gift-disclosure"
    />
  );
}
